import { reactive } from "vue";

export const settingStore = reactive({
    isFixed: 0,
    isWindow: 0,
    isShowPenChange: 0,
    isPenClick: 0,
    useCustomPlayer: 0,
    toolbarPosition: 0
});